import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

import {
	Box,
	CloseButton,
	ContentWithTooltip,
	Group,
} from '@ekhodealer/ekho-common/rev';

import type {
	RevProps} from '@ekhodealer/ekho-common/rev';

import './FloatingActionMenu.scss';

export interface FloatingActionMenuProps extends RevProps {
	isOpen: boolean;
	onClose: () => void;
	leftContent?: React.ReactNode;
	rightContent?: React.ReactNode;
	closeButtonTooltip?: string;
}

export function FloatingActionMenu(props: FloatingActionMenuProps) {
	const CloseBtn = () => {
		const Btn = (
			<CloseButton size='medium' variant='secondary' rounding='10' onPress={props.onClose} />
		);

		if (props.closeButtonTooltip) {
			return (
				<ContentWithTooltip
					content={Btn}
					tooltipContent={props.closeButtonTooltip}
					tooltipProps={{ placement: 'top' }}
				/>
			);
		} else {
			return Btn;
		}
	};

	return (
		<AnimatePresence>
			{props.isOpen && (
				<div
					className='floating-action-menu'
					data-placement='bottom'>
					<motion.div
						initial={{ opacity: 0, scale: 0.96, y: 16 }}
						animate={{ opacity: 1, scale: 1, y: 0 }}
						exit={{ opacity: 0, scale: 0.96, y: 16 }}
						transition={{
							type: 'spring',
							stiffness: 700,
							damping: 28,
						}}>
						<Box elevation='6' rounding='16' padding='16' background='primary'>
							<Group
								noWrap
								itemsAlignY='center'
								itemsAlignX='space-between'
								itemsSpacing='8'>
								<Group
									noWrap
									itemsAlignY='center'
									itemsAlignX='start'
									itemsSpacing='8'>
									<CloseBtn />
									<div className='left-content'>{props.leftContent}</div>
								</Group>
								<div className='right-content'>{props.rightContent}</div>
							</Group>
						</Box>
					</motion.div>
				</div>
			)}
		</AnimatePresence>
	);
}
